import ReactPlayerOriginal from 'react-player'

/* reexported with a TS type because original module has default export */
export const ReactPlayer =
  ReactPlayerOriginal as unknown as typeof ReactPlayerOriginal.default
